module.exports = __webpack_public_path__ + "../static/img/base_reap_rax700.07f1659f.png";